<template>
  <div>
    <div class="columns">
      <div class="column">
        <!--pdf view canvas-->
        <div style="height:1000px;width:100%; overflow-x: scroll;"  id="drop-zone" class="drop-zone">
          <div id="mypdf">
            <!--placeholders data-->
            <div v-for="element in CoordianteArr" :key="element.id">
              <!-- signature element-->
              <div v-if="element.type=='signature'" :id="element.id" >
                <b-tag type="is-primary">Signature {{element.id}}</b-tag>
              </div>

              <!--checkbox element-->
              <div v-if="element.type=='checkbox'" :id="element.id" >
                <b-tag  type="is-success">checkbox {{element.id}}</b-tag>
              </div>

              <!--text field element-->
              <div v-if="element.type=='text-box'" :id="element.id">
                <b-tag type="is-info" >text-box {{element.id}}</b-tag>
              </div>

              <!--datepicker element-->
              <div v-if="element.type=='date-picker'" :id="element.id">
                <b-tag  type="is-warning">Date-picker {{element.id}}</b-tag>
              </div>

            </div>

            <!--pdf view-->
            <canvas :id="'the-canvas'+render"  style="width: 800px; height: 1100px" v-for="render in TotPage" :key="render.id"></canvas>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import html2pdf from 'html2pdf.js'
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

export default {

  name:'document-view',


  components:{

  },

  data() {

    return {

      document_url:'',

      //pdf render
      TotPage:'',
      Pageindex:[],
      elementCount:'',

      // current document data --------------------------------------
      currentDocTotalPlaceholders : 0,
      currentDocCompletedPlaceholders : 0 , // should be default to 0

      CoordianteArr:[],

      coordinateAdjustRatio:{
        x:1,
        y:1.035,
      },
      comments:[]

    }
  },

  methods:{


    getCoordinates:function (){
      var component = this
      axios.post(component.$base_url+'/agent/getItemforEdit',{
        template_id:component.$route.params.id,
        auth_token:component.$root.agentAuthToken,
      })
          .then(function (response){

            if(response.data.success == true){
              console.log(response.data.data)
              component.CoordianteArr = response.data.data.coordinates
              component.document_url = response.data.data.document_path

              // component.PlaceholdersData =JSON.parse(arr.data.inviteeData.coordinates)
              // component.currentDocTotalPlaceholders= component.PlaceholdersData.length
              setTimeout(() => {
                component.AppendPlaceholdersToBody();
                component.renderPDF()
              }, 300)
            }else{
              //show alert
              component.$buefy.toast.open({
                message: 'Failed get coordinates',
                type: 'is-danger'
              })
            }

          }).catch(function (error) {
        console.log(error);
      });
    },


    //add placeholders to body
    AppendPlaceholdersToBody:function (){
      var component = this
      component.CoordianteArr.forEach((placeholder) => {
        console.log('element list  ' + placeholder)

        placeholder.Xcord = (placeholder.Xcord)*component.coordinateAdjustRatio.x
        placeholder.Ycord = (placeholder.Ycord)*component.coordinateAdjustRatio.y

          var elm = document.getElementById(placeholder.id);
          // var content = document.getElementById('pdfview-1')
          console.log(elm);
          if(placeholder.type == 'signature'){
            elm.style.border='none';

          }else if(placeholder.type == 'date-picker'){

            elm.style.border='none';

          }

          elm.style.left = placeholder.Xcord+'px'
          elm.style.top = placeholder.Ycord+'px'
          elm.style.padding =10+'px'
          elm.style.position='absolute';
          elm.style.display='inline';
        })



    },

    renderPDF:function () {
      var component = this
      var url = component.$base_public_url+component.document_url;
      console.log('url---------'+url)
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(url);

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page

        var totalpages = pdf.numPages;
        component.TotPage = totalpages

        for(var x= 1; x <= totalpages; x++){
          component.Pageindex.push({pageIndex:x})
        }

        if(totalpages > 1) {
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }


      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });
    },

    //get signature image URL
    getSignature(e){

      if(e.signature){
        console.log(e.signature.imageUrl)
        // TODO :: assign returned signature to the placeholder
        console.log("Signature received")
        return e.signature.imageUrl
      }
    },

    //show comment comp
    showCommentComp(){
      this.showAddComments =true
      this.showOTPComp = false
    }



  },

  mounted() {
    this.getCoordinates()
  }

}
</script>

<style scoped>

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.modal-card-body{
  border-radius: 0 0 5px 5px;
}

#mypdf{
  position: relative;
}

#drop-zone{
  position: relative;
}


</style>



